import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Button from '../../components/Button/Button';
import styles from './Notifications.module.css';

const Notifications = () => {
  const [activeTab, setActiveTab] = useState('all');

  const tabs = [
    { id: 'all', label: 'All logs' },
    { id: 'sent', label: 'Sent', count: 2 },
    { id: 'scheduled', label: 'Scheduled', count: 1 }
  ];

  const notificationsList = [
    {
      id: 1,
      title: 'New gaming studies in Delhi',
      audience: 'Participants · Delhi NCR · 18–25',
      channel: 'Push + WhatsApp',
      delivered: '3,120',
      opened: '41%',
      status: { label: 'Sent', color: '#007A21', bg: '#DCFFE5' }
    },
    {
      id: 2,
      title: 'Upload your UPI to get paid faster',
      audience: 'Participants without UPI',
      channel: 'Push',
      delivered: '1,860',
      opened: '28%',
      status: { label: 'Sent', color: '#007A21', bg: '#DCFFE5' }
    },
    {
      id: 3,
      title: 'Pro plan: 10% service fee',
      audience: 'Free researchers',
      channel: 'Email',
      delivered: '110',
      opened: '—',
      status: { label: 'Scheduled Oct 01', color: '#0060D4', bg: '#ECF4FF' }
    },
    {
      id: 4,
      title: 'Diwali payout timings',
      audience: 'All participants',
      channel: 'Push',
      delivered: '—',
      opened: '—',
      status: { label: 'Draft', color: '#60606B', bg: '#F2F2F2' }
    }
  ];

  const filteredNotifications = notificationsList.filter((item) => {
    if (activeTab === 'sent') return item.status.label === 'Sent';
    if (activeTab === 'scheduled') return item.status.label.includes('Scheduled');
    return true;
  });

  const headerActions = (
    <Link to="/send-notification">
      <Button variant="primary">+ New notification</Button>
    </Link>
  );

  return (
    <>
      <PageHeader
        title="Notifications"
        subtitle="Announcements to participants and researchers."
        actions={headerActions}
      />

      <FilterTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Notification</div>
          <div>Channel</div>
          <div>Delivered</div>
          <div>Opened</div>
          <div>Status</div>
        </div>

        {filteredNotifications.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <div>
              <div className={styles.notifInfo}>
                <span className={styles.notifTitle}>{item.title}</span>
                <span className={styles.notifAudience}>{item.audience}</span>
              </div>
            </div>
            <div className={styles.channelText}>{item.channel}</div>
            <div className={styles.deliveredText}>{item.delivered}</div>
            <div className={styles.openedText}>{item.opened}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: item.status.color, background: item.status.bg }}
              >
                {item.status.label}
              </span>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Notifications;
